export type SettingKey =
  | "terminal"
  | "maxTabs"
  | "hideWithoutRelated"
  | "motionHighlight"
  | "bmotionHighlight"
  | "maxMCHighlight"
  | "totalPairFeesHighlight"
  | "negativeHighlight";

export type SettingType = "select" | "number" | "switch" | "title";

export interface SettingConfigItem {
  key?: SettingKey;
  label: string;
  type: SettingType;

  // for select type
  options?: Array<{ label: string; value: string | number }>;

  // for number type
  min?: number;
  max?: number;

  // optional tooltip text to show on hover
  tooltip?: string;
}

export const settingsConfig: SettingConfigItem[] = [
  {
    key: "terminal",
    label: "Terminal to Open",
    type: "select",
    options: [
      { label: 'Axiom', value: 'axiom' },
      { label: 'Padre', value: 'padre' },
      { label: 'GmGn', value: 'gmgn' },
      { label: 'Photon', value: 'photon' },
      { label: 'Bullx', value: 'bullx' },
      { label: 'Trojan', value: 'trojan' },
    ],
  },
  {
    key: "maxTabs",
    label: "Auto Tabs Limit",
    type: "number",
    min: 1,
    max: 20,
  },
  {
    key: "hideWithoutRelated",
    label: "Hide Pairs Without Related",
    type: "switch",
  },
  {
    label: "Highlight",
    type: "title",
  },
  {
    key: "motionHighlight",
    label: "Motion If",
    type: "select",
    options: [
      { label: ">= 10%", value: 10 },
      { label: ">= 20%", value: 20 },
      { label: ">= 30%", value: 30 },
      { label: ">= 40%", value: 40 },
      { label: ">= 50%", value: 50 },
    ],
    tooltip: `Highlight the pair if Motion % is greater or equal the selected value.`,
  },
  {
    key: "bmotionHighlight",
    label: "BMotion If",
    type: "select",
    options: [
      { label: ">= 10%", value: 10 },
      { label: ">= 20%", value: 20 },
      { label: ">= 30%", value: 30 },
      { label: ">= 35%", value: 35 },
      { label: ">= 40%", value: 40 },
      { label: ">= 50%", value: 50 },
    ],
    tooltip: `Highlight the pair if BMotion % is greater or equal than the selected value.`,
  },
  {
    key: "maxMCHighlight",
    label: "Max Market Cap If",
    type: "select",
    options: [
      { label: ">= 50%", value: 50 },
      { label: ">= 75%", value: 75 },
      { label: ">= 100%", value: 100 },
      { label: ">= 150%", value: 150 },
      { label: ">= 200%", value: 200 },
    ],
    tooltip: `Highlight the pair if Max Market Cap % is greater or equal the selected value.`,
  },
  {
    key: "totalPairFeesHighlight",
    label: "Total Pair Fees >=",
    type: "number",
    min: 0,
    tooltip: `Highlight the pair if Total Pair Fees Paid is greater or equal the entered value.`,
  },
  {
    key: "negativeHighlight",
    label: "Highlight Negative Values",
    type: "switch",
  },
];
